import {Suspense} from "react";
import {Helmet} from "react-helmet-async";

import {Card} from "@/components/card/Card.tsx";
import {useCurrentUserContext} from "@/components/context/hooks.ts";
import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {getLink, PageLink} from "@/lib/links.ts";
import {APITokensContent} from "@/pages/apitokens/APITokensContent.tsx";

export const APITokensPage = () => {
  const {brand} = useCurrentUserContext();

  return (
    <ContentContainer title="API">
      <Helmet>
        <title>API</title>
      </Helmet>
      <Suspense>
        <UpErrorBoundary>
          <APITokensContent />
        </UpErrorBoundary>
        <div>
          <h5 className="heading fw-bold mb-4 mt-5">API Documentation</h5>
          <Card variant="white">
            For more information please review our{" "}
            <a target="_blank" href={getLink(brand, PageLink.API_DOCS)}>
              Documentation
            </a>
            ,{" "}
            <a target="_blank" href={getLink(brand, PageLink.BROWSABLE_API)}>
              Browsable API
            </a>
            {" and "}
            <a target="_blank" href="https://status.uptime.com/statuspage/api-changelog">
              API Changelog
            </a>
            .
          </Card>
        </div>
      </Suspense>
    </ContentContainer>
  );
};
